import React from "react";
import {Link} from "react-router-dom";
import './listacliente.css';

function ListaClientes(props){ 
   return <table className="table table-hover table-bordered">
    <thead>
      <tr className="table-secondary">

        <th scope="col">Nome</th>
        <th scope="col">SIAPE</th>
        <th scope="col">CPF</th>
        <th scope="col">Processo</th>
        <th scope="col">Valor</th>
        <th scope="col">Alter</th>
        <th scope="col" className='col-acao'></th>
      </tr>
    </thead>
    <tbody>

    {
        props.arrayClientes.map(function(cliente){
            return <tr  key={cliente.id}>

            <td>{cliente.nome}</td>
            <td>{cliente.siape}</td>
            <td>{cliente.cpf}</td>
            <td>{cliente.processo}</td>
            <td>{cliente.valor}</td>
            <td>{cliente.alter}</td>

            <td>
               <Link to={'/app/editarcliente/' + cliente.id} ><i className="fa-solid fa-pen-to-square icone-acao"></i></Link>
               <Link to='#' onClick={()=>props.clickDelete(cliente.id)}><i className="fa-sharp fa-solid fa-trash icone-acao red"></i></Link>
            </td>
          </tr>    
        })
    }

      
    </tbody>
  </table>
}
export default ListaClientes;